export enum AuditAdded {
  Active = 'Active',
  True = 'True',
  False = 'False',
}
